module.exports = __webpack_public_path__ + "static/media/item-5.4080e7b9.png";